export const STATUSES = {
    LIVE: 'live',
    EDIT: 'edit',
    UPGRADE: 'upgrade',
    LIMIT_REACHED: 'limit',
    PENDING_CNAME: 'pending_cname',
    PENDING_CERTIFICATE: 'pending_certificate',
    ERROR: 'error',
};

export const STATUSES_COLOR_MAP = {
    [STATUSES.LIVE]: 'var(--green300)',
    [STATUSES.EDIT]: 'var(--orange300)',
    [STATUSES.UPGRADE]: 'var(--orange300)',
    [STATUSES.LIMIT_REACHED]: 'var(--orange300)',
    [STATUSES.PENDING_CNAME]: 'var(--blue300)',
    [STATUSES.PENDING_CERTIFICATE]: 'var(--blue300)',
};

export const DOMAIN_TYPES = {
    BRANDED: 'Branded',
    SINGULAR: 'Singular',
};

export const TABLE_KEYS = {
    DOMAIN: 'domain',
    DOMAIN_TYPE: 'domain_type',
    STATUS: 'status',
    ACTIONS: 'actions',
};

export const TRANSLATION_PREFIX = 'STATIC.PAGES.MANAGE_LINKS.SUB_DOMAIN.TABLE';
export const DOMAIN_LIMIT_WARNING_KEY = 'ALERTS.LIMIT_REACHED_WARNING';
export const UPGRADE_PLAN_WARNING_KEY = 'ALERTS.UPGRADE_PLAN';
export const ONLY_ADMIN_WARNING_KEY = 'ALERTS.ONLY_ADMIN';
export const BRANDED_LIMIT_REACHED_WARNING_KEY = 'ALERTS.BRANDED_LIMIT_REACHED_WARNING';
export const DNS_ZONE = 'sng.link';

export const COLUMN_NAMES = {
    DOMAIN_TYPE: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.DOMAIN_TYPE`,
    DOMAIN: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.DOMAIN`,
    STATUS: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.STATUS`,
    ACTIONS: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.ACTIONS`,
};

export const STATUS_TEXT_KEYS = {
    LIVE: `${TRANSLATION_PREFIX}.STATUS.LIVE`,
    UPGRADE: `${TRANSLATION_PREFIX}.STATUS.UPGRADE_REQUIRED`,
    EDIT: `${TRANSLATION_PREFIX}.STATUS.EDIT`,
    LIMIT_REACHED: `${TRANSLATION_PREFIX}.STATUS.LIMIT_REACHED`,
    PENDING_CERTIFICATE: `${TRANSLATION_PREFIX}.STATUS.PENDING_CERTIFICATE`,
    PENDING_CNAME: `${TRANSLATION_PREFIX}.STATUS.PENDING_CNAME`,
};

export const STATUS_SUB_VALUES = {
    [STATUSES.EDIT]: `${TRANSLATION_PREFIX}.SUB_STATUS.EDIT`,
    [STATUSES.LIVE]: `${TRANSLATION_PREFIX}.SUB_STATUS.LIVE`,
    [STATUSES.LIMIT_REACHED]: `${TRANSLATION_PREFIX}.SUB_STATUS.LIMIT_REACHED`,
    [STATUSES.UPGRADE]: `${TRANSLATION_PREFIX}.SUB_STATUS.UPGRADE`,
    [STATUSES.PENDING_CERTIFICATE]: `${TRANSLATION_PREFIX}.SUB_STATUS.PENDING_CERTIFICATE`,
    [STATUSES.PENDING_CNAME]: `${TRANSLATION_PREFIX}.SUB_STATUS.PENDING_CNAME`,
};

export const VALIDATION_MESSAGES = {
    REQUIRED: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.REQUIRED`,
    INVALID_FORMAT: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.INVALID_FORMAT`,
    DUPLICATE: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.DUPLICATE`,
};

export const DOMAIN_TYPE_OPTIONS = [
    { name: 'singular', display_name: DOMAIN_TYPES.SINGULAR },
    { name: 'branded', display_name: DOMAIN_TYPES.BRANDED },
];

export const TTypeEnum = {
    ALERT: 'alert',
    ERROR: 'error',
    INFO: 'info',
};
